export interface SystemFeatureType {
	systemFeatureTypeId: number,
	systemFeatureTypeName: string
}
export const B2GnowSystemFeature : SystemFeatureType = {
	systemFeatureTypeId: 1,
	systemFeatureTypeName: "B2Gnow"
}

export const VssSystemFeature : SystemFeatureType = {
	systemFeatureTypeId: 2,
	systemFeatureTypeName: "Vendor Sourcing Solution"
}